import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "mt-2 nodeinfo3"
};
const _hoisted_2 = {
  key: 0,
  class: "row"
};
const _hoisted_3 = {
  class: "col-12"
};
const _hoisted_4 = {
  class: "mb-4"
};
const _hoisted_5 = {
  class: "row mt-2"
};
const _hoisted_6 = {
  class: "col-12"
};
const _hoisted_7 = {
  class: "i-layer"
};
const _hoisted_8 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_9 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_10 = {
  key: 1,
  class: "row"
};
const _hoisted_11 = {
  class: "col-12"
};
const _hoisted_12 = {
  class: "mb-4"
};
const _hoisted_13 = {
  class: "row mt-2"
};
const _hoisted_14 = {
  class: "col-12"
};
const _hoisted_15 = {
  class: "i-layer"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-16"
}, "STFIL Staking Pool")], -1);
const _hoisted_17 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium",
  style: {
    "width": "80px",
    "color": "#787A9B"
  }
}, "ETH:", -1);
const _hoisted_19 = {
  class: "fw-bold"
};
const _hoisted_20 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_21 = {
  class: "fw-medium",
  style: {
    "width": "80px",
    "color": "#787A9B"
  }
};
const _hoisted_22 = {
  class: "fw-bold"
};
const _hoisted_23 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium",
  style: {
    "width": "80px",
    "color": "#787A9B"
  }
}, "ID:", -1);
const _hoisted_25 = {
  class: "fw-bold"
};
const _hoisted_26 = {
  key: 1,
  class: "row mt-2"
};
const _hoisted_27 = {
  class: "col-12"
};
const _hoisted_28 = {
  class: "row mt-2"
};
const _hoisted_29 = {
  class: "col-12"
};
const _hoisted_30 = {
  class: "pl-4 pr-4"
};
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-16"
}, "New Owner(STFIL Staking Pool)")], -1);
const _hoisted_32 = {
  class: "fsi-14 d-flex align-items-center justify-content-between"
};
const _hoisted_33 = {
  class: "fw-medium",
  style: {
    "min-width": "80px",
    "width": "80px",
    "color": "#787A9B"
  }
};
const _hoisted_34 = {
  class: "col-12"
};
const _hoisted_35 = {
  class: "row mb-3"
};
const _hoisted_36 = {
  class: "col-12 text-left fw-extra-bold fsi-20"
};
const _hoisted_37 = {
  class: "i-layer mt-1 mb-3"
};
const _hoisted_38 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_39 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_40 = {
  class: "i-layer mb-4"
};
const _hoisted_41 = {
  class: "row mt-3",
  ref: "nodeinfo3"
};
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "Address", -1);
const _hoisted_43 = {
  class: "col-lg-9 col-12 d-flex fw-medium fs-lg-14 fs-12 justify-content-lg-end"
};
const _hoisted_44 = {
  class: "row mt-3"
};
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "ID", -1);
const _hoisted_46 = {
  key: 1,
  class: "row mt-3",
  ref: "nodeinfo3"
};
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "Address", -1);
const _hoisted_48 = {
  class: "col-lg-9 col-12 d-flex fw-medium fs-lg-14 fs-12 justify-content-lg-end"
};
const _hoisted_49 = {
  class: "row mt-3"
};
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "Actor", -1);
const _hoisted_51 = {
  class: "col-lg-9 col-12 text-lg-right fw-medium fs-lg-14 fs-12"
};
const _hoisted_52 = {
  class: "row mt-3"
};
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-5 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "Approval Threshold", -1);
const _hoisted_54 = {
  class: "col-lg-7 col-12 text-lg-right fw-medium fs-lg-14 fs-12"
};
const _hoisted_55 = {
  class: "row mt-3"
};
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-5 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "No. of Singer", -1);
const _hoisted_57 = {
  class: "col-lg-7 col-12 text-lg-right fw-medium fs-lg-14 fs-12"
};
const _hoisted_58 = {
  class: "row"
};
const _hoisted_59 = {
  class: "col-12 text-left fw-bold fsi-20 cursor-pointer"
};
const _hoisted_60 = {
  key: 0,
  class: "row"
};
const _hoisted_61 = {
  class: "col-12"
};
const _hoisted_62 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_63 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tip = _resolveComponent("Tip");
  const _component_Singer = _resolveComponent("Singer");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_step = _resolveComponent("el-step");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _component_el_steps = _resolveComponent("el-steps");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!$data.isBeneficiary ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_Tip, {
    level: "tips"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('farm.console.The current node delegate role is not beneficiary')), 1)])])])])]),
    _: 1
  })])])])) : _createCommentVNode("", true), $data.isBeneficiary ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [$data.step < 1 ? (_openBlock(), _createBlock(_component_Tip, {
    key: 0,
    level: "tips"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, _toDisplayString($data.contracts[_ctx.$store.state.evn].StakingPool.eth), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('Onboarding.Address')) + ":", 1), _createElementVNode("div", _hoisted_22, _toDisplayString($data.contracts[_ctx.$store.state.evn].StakingPool.address), 1)]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, _toDisplayString($data.contracts[_ctx.$store.state.evn].StakingPool.id), 1)])])])])]),
    _: 1
  })) : _createCommentVNode("", true), $data.step >= 1 ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_Tip, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('Onboarding.Address')) + ":", 1), _createElementVNode("div", {
      class: "fw-bold link-text-ordinary",
      style: {
        "min-width": "100px"
      },
      onClick: _cache[0] || (_cache[0] = $event => $options.gotoAddress($data.contracts[_ctx.$store.state.evn].StakingPool.address, _ctx.$i18n.locale))
    }, _toDisplayString($data.contracts[_ctx.$store.state.evn].StakingPool.address), 1)])])])])]),
    _: 1
  })])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_el_steps, {
    direction: "vertical",
    active: $data.active
  }, {
    default: _withCtx(() => [_createVNode(_component_el_step, null, _createSlots({
      title: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('Onboarding.Submit a')) + " \"Change" + _toDisplayString($options.nodeRole === 'Beneficiary' ? $options.nodeRole : $options.nodeRole + 'Address') + "\" " + _toDisplayString(_ctx.$t('Onboarding.proposal')), 1)])]),
      _: 2
    }, [!$data.isError ? {
      name: "description",
      fn: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, "Original " + _toDisplayString($options.nodeRole), 1)]), _createElementVNode("div", _hoisted_40, [!$options.singerMultiple ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_41, [_hoisted_42, _createElementVNode("div", _hoisted_43, [_createElementVNode("div", {
        style: _normalizeStyle(`width: ${_ctx.fixedMaxWidth}`),
        class: "link-text-ordinary text-lg-right",
        onClick: _cache[1] || (_cache[1] = $event => $options.gotoAddress($options.nodeInfo[`${$options.nodeRole.toString().toLowerCase()}Address`], _ctx.$i18n.locale))
      }, _toDisplayString($options.nodeInfo[`${$options.nodeRole.toString().toLowerCase()}Address`]), 5)])], 512), _createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", {
        class: "col-lg-9 col-12 text-lg-right fw-medium fs-lg-14 fs-12 link-text-ordinary",
        onClick: _cache[2] || (_cache[2] = $event => $options.gotoAddress($options.nodeInfo[`${$options.nodeRole.toString().toLowerCase()}`], _ctx.$i18n.locale))
      }, _toDisplayString($options.nodeInfo[`${$options.nodeRole.toString().toLowerCase()}`]), 1)])], 64)) : _createCommentVNode("", true), $options.singerMultiple ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
        style: _normalizeStyle(`width: ${_ctx.fixedMaxWidth}`),
        class: "link-text-ordinary text-right",
        onClick: _cache[3] || (_cache[3] = $event => $options.gotoAddress($options.nodeInfo[$options.nodeRole.toString().toLowerCase()], _ctx.$i18n.locale))
      }, _toDisplayString($options.nodeInfo[$options.nodeRole.toString().toLowerCase()]), 5)])], 512)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, _toDisplayString($options.singerMultiple ? 'Multisig' : 'Account'), 1)]), $options.singerMultiple ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createElementVNode("div", _hoisted_52, [_hoisted_53, _createElementVNode("div", _hoisted_54, _toDisplayString($options.singerMultipleThreshold), 1)]), _createElementVNode("div", _hoisted_55, [_hoisted_56, _createElementVNode("div", _hoisted_57, _toDisplayString($options.singerMultipleNum), 1)])], 64)) : _createCommentVNode("", true)]), _createVNode(_component_Singer, {
        ref: "singer",
        nodeRole: $options.nodeRole,
        singerMultiple: $options.singerMultiple,
        nodeInfo: $options.nodeInfo,
        singerType: "submit",
        changeAddress: $data.changeAddress,
        onInitErr: $options.singleSignatureInitErr,
        btnProposal: "Send Proposal",
        onNext: $options.showNextStepBtnFun,
        originalSingerTables: $data.singerTables
      }, null, 8, ["nodeRole", "singerMultiple", "nodeInfo", "changeAddress", "onInitErr", "onNext", "originalSingerTables"]), $data.showNextStepBtn ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: $options.pushProposalNext,
        class: "btn btn-primary w-100 i-button",
        type: "submit"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Next')), 1)]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)])]),
      key: "0"
    } : undefined]), 1024), _createVNode(_component_el_step, null, {
      title: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('Onboarding.Approval proposal by STFIL staking pool')), 1)])]),
      description: _withCtx(() => [_createElementVNode("div", null, [$data.step >= 2 ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createVNode(_component_Singer, {
        ref: "singer2",
        nodeRole: $options.nodeRole,
        singerMultiple: $options.singerMultiple,
        "contract-method": $data.contractMethod,
        btnProposal: "Approved Proposal",
        contractParams: $data.contractParams,
        nodeInfo: $options.nodeInfo,
        onNext: $options.pushProposalNext2,
        originalSingerTables: $data.singerTables
      }, null, 8, ["nodeRole", "singerMultiple", "contract-method", "contractParams", "nodeInfo", "onNext", "originalSingerTables"])])])) : _createCommentVNode("", true), $data.step >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createVNode(_component_AdCard2, {
        title: _ctx.$t('farm.console.Successfully upgraded to Owner delegate'),
        content: _ctx.$t('Onboarding.Please take good care the original owner'),
        "btn-text": _ctx.$t('Onboarding.View Node'),
        "main-btn-text": _ctx.$t('farm.console.ApproveOperator'),
        onBtnClick: $options.viewNode,
        onMainBtnClick: $options.ApproveOperator
      }, null, 8, ["title", "content", "btn-text", "main-btn-text", "onBtnClick", "onMainBtnClick"])])])) : _createCommentVNode("", true)])]),
      _: 1
    })]),
    _: 1
  }, 8, ["active"])])])) : _createCommentVNode("", true)]);
}